import React, { Component } from 'react'
import './styles.scss'

export default class Methodik extends Component {
  state = { isOpen: false }

  handleClick = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  render() {
    const { activeIndex } = this.state

    return (
      <div className={this.state.isOpen ? 'methodik open' : 'methodik closed'}>
        <div className='title' onClick={this.handleClick}>
          <i
            className={
              this.state.isOpen ? 'icon caret down' : 'icon caret right'
            }
          />
          {this.props.title}
        </div>
        <div className='content'>{this.props.children}</div>
      </div>
    )
  }
}
